import React from 'react';

/**
 * Seed control — LCD-style readout with shuffle button.
 * Monospace green text in a dark recessed display.
 */
export function GenArtSeedControl({ seed, onChange }) {
  const shuffleSeed = () => {
    onChange(Math.floor(Math.random() * 10000));
  };

  return (
    <div>
      <div className="text-[10px] text-white/40 mb-1.5 uppercase tracking-wider">Seed</div>
      <div className="flex items-center gap-2">
        {/* LCD seed readout */}
        <div className="genart-seed-lcd">
          <input
            type="number"
            value={seed}
            onChange={(e) => {
              const v = parseInt(e.target.value, 10);
              if (!isNaN(v)) onChange(v);
            }}
            className="genart-seed-input"
          />
        </div>
        {/* Shuffle button */}
        <button
          onClick={shuffleSeed}
          className="btn-instrument btn-instrument-sm"
          title="Random seed"
        >
          <span style={{ fontSize: '13px' }}>🎲</span> Shuffle
        </button>
      </div>
    </div>
  );
}
